import React from 'react';

const TrainingCalendar = () => {
  return (
    <div>
      <h1>Training Calendar</h1>
      <p>View our upcoming training schedules and register today.</p>
    </div>
  );
};

export default TrainingCalendar;
